
import Vue from "vue";
export default Vue.extend({
  name: "RenewAffiliateRequest",
  props: {
    registration: { type: Object },
  },
});
